/**
 * Given the current pathname, return the counterpart path in the other
 * language. Used by the ES/EN toggle in Navbar/ShopNav so that flipping
 * language on any bilingual route also navigates to the correct URL.
 *
 * Falls back to the current path when a mapping is not known (rare — most
 * bilingual routes are covered).
 */
const ES_TO_EN = new Map([
  ["/", "/en"],
  ["/tienda", "/shop"],
  ["/blog", "/journal"],
  ["/contacto", "/contact"],
  ["/premio-sabor-granada-2023", "/en/sabor-granada-award-2023"],
]);
const EN_TO_ES = new Map([
  ["/en", "/"],
  ["/shop", "/tienda"],
  ["/journal", "/blog"],
  ["/contact", "/contacto"],
  ["/en/sabor-granada-award-2023", "/premio-sabor-granada-2023"],
]);

export function counterpartPath(pathname, nextLang) {
  if (!pathname) return nextLang === "es" ? "/" : "/en";
  const clean = pathname.replace(/\/+$/, "") || "/";

  if (nextLang === "en") {
    // Exact match first
    if (ES_TO_EN.has(clean)) return ES_TO_EN.get(clean);
    // Blog article: /blog/{slug_es} → /journal/{slug_en} — we can't know the
    // counterpart slug without the DB, so send them to the EN index. Better
    // than a broken translation URL.
    if (clean.startsWith("/blog/")) return "/journal";
    if (clean.startsWith("/producto/")) {
      // Product slugs are shared between ES and EN, only the prefix changes.
      return "/product/" + clean.slice("/producto/".length);
    }
    // Legal, checkout, cart, admin, faq etc. — no dedicated EN route, keep path.
    return clean;
  }

  // nextLang === "es"
  if (EN_TO_ES.has(clean)) return EN_TO_ES.get(clean);
  if (clean.startsWith("/journal/")) return "/blog";
  if (clean.startsWith("/product/")) {
    return "/producto/" + clean.slice("/product/".length);
  }
  return clean;
}
